<template>
	<div id="qe_right1">
		<div class="cc-header">荣誉情况</div>
		<div class="main-value" id="honor_count"></div>
	</div>
</template>

<script>
	var storage = window.localStorage;
	var orgCode = storage.getItem("orgCode");
	const echarts = require("echarts");
	export default {
		data() {
			return {
			};
		},
		mounted() {
			this.initData();
			// 定时器刷新，1小时
			let _this = this;
			setInterval(() => {
				_this.initData();
			}, 1000 * 60 * 60);
		},
		methods: {
			initData() {
				let _this = this;
				// 基于准备好的dom，初始化echarts实例
				let honourChart = echarts.init(document.getElementById("honor_count"));
				this.$http.get("/dataView/quality/edu/getHonourCountByLeave?orgCode=" + orgCode + "&termName=" + _this.$parent.$parent.$parent.termName).then(res => {
					if (res.data.code === 200) {
						var leaveList = res.data.result.leaveList;
						var typeList = res.data.result.typeList;
						var leaveData = [];
						var typeData = [];
						for (var i = 0; i < leaveList.length; i++) {
							leaveData.push({name: leaveList[i].leaveName,value: leaveList[i].leaveCount});
						}
						for (var j = 0; j < typeList.length; j++) {
							typeData.push({name: typeList[j].typeName,value: typeList[j].typeCount});
						}

						var option = {
							tooltip: {
								trigger: 'item',
								formatter: function(params) {
									var relVal = '学生荣誉<br/>' + params.marker + '&nbsp;' + params.name + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>' + params.value + '</b>项';
									return relVal
								}
							},
							legend: {
								show: false,
								textStyle: {
									fontSize: fontSize(0.15),
									height: 13,
									rich: {
										a: {
											verticalAlign: 'middle'
										}
									},
									color: '#54beff' // 把颜色这里做成函数就可以了
								},
								bottom: '10',
								itemWidth: 15,
								itemHeight: 13
							},
							series: [{
									name: '',
									type: 'pie',
									selectedMode: 'single',
									radius: [0, '40%'],
									center: ['50%', '50%'],
									avoidLabelOverlap: true,
									data: leaveData,
									itemStyle: {
										normal: {
											label: {
												show: true,
												position: 'inner',
												textStyle: {
													color: '#ffffff',
													lineHeight: 15,
													fontSize: fontSize(0.12)
												},
												formatter: function(p) {
													return p.name + '\n' + p.percent + "%";
												}
											},
											color: function (colors) {
												var colorList = ['#673AB7','#ffdf33','#00BCD4','#fd87ab','#8BC34A','#c23531'];
												return colorList[colors.dataIndex];
											}
										}
									}
								},
								{
									name: '',
									type: 'pie',
									radius: ['48%', '60%'],
									center: ['50%', '50%'],
									avoidLabelOverlap: false,
									data: typeData,
									itemStyle: {
										normal: {
											label: {
												show: true,
												//alignTo: 'edge',//外边框对齐
												margin: 5,
												textStyle: {
													//color: 'inherit',//继承数据颜色
													color: '#54beff',
													lineHeight: 18,
													fontSize: fontSize(0.15)
												},
												formatter: function(p) {
													return p.name + '\n' + p.percent + "%";
												}
											},
											// labelLine: {
											// 	length: 20,
											// 	length2: 10
											// },
											color: function (colors) {
												var colorList = ['#3F51B5','#FF9800','#d48265','#795548','#61a0a8'];
												return colorList[colors.dataIndex];
											}
										}
									}
								}
							]
						};
						honourChart.setOption(option);
						// 响应式变化
						window.addEventListener("resize", () => honourChart.resize(), false);
					}
				})
			}
		},
		destroyed() {
			window.onresize = null;
		}
	};

	function fontSize(res) {
		let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		if (!clientWidth) return;
		let fontSize = 100 * (clientWidth / 1920);
		return res * fontSize;
	}
</script>

<style lang="scss">
	#qe_right1 {
		height: 100%;
		padding: 0 2%;

		.cc-header {
			width: 100%;
			padding-top: 0.25rem;
			color: #00ffff;
			font-size: 0.25rem;
			text-align: center;
			height: 10%;
		}

		.cc-header span {
			color: #ffff00;
			font-weight: bold;
			padding: 0 0.03rem;
		}

		.main-value {
			height: 88%;
		}
	}
</style>